import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";
import { RadioList } from "./RadioList";
import { Repeater, RepeaterItem } from "./Repeater";

export class F24_2014 extends BaseForm {
    override updateForm() {

        //this.JOINT_PROCUREMENT_INVOLVED_change();
        //this.ADDRESS_FURTHER_INFO_change();
        //this.URL_TOOL_use_change();
        //this.economic_criteria_change;
        //this.DOCUMENT_change();
    }
}

export class F24_2014_OBJECT_CONTRACT extends BaseWidget {
}

export class F24_2014_OBJECT_DESCR_ITEM extends RepeaterItem {
}

export class F24_2014_PROCEDURE extends BaseWidget {
    private noticeNumberErrMsg: HTMLElement|null = null;

    NOTICE_NUMBER_OJ_change(sender) {
        const el: HTMLInputElement = this.ui.NOTICE_NUMBER_OJ as HTMLInputElement;

        typeof this.checkFormat(el as HTMLInputElement, "NoticeNumber") === "string" && el.value.length > 0
            ? this.addErrorToElement(el, this.checkFormat(el as HTMLInputElement, "NoticeNumber") as string)
            : this.removeErrorFromElement(el);
    }
}

export class F24_2014_AWARD_OF_CONTRACT extends RepeaterItem {
    repeater: Repeater;

    afterIndex(): void {
        this.AWARDED_TO_GROUP_change();
    }

    AWARDED_TO_GROUP_change() {
        this.repeater = this.muNamedWidget.ADDRESS_CONTRACTOR as Repeater;
        this.repeater.maxCount = (this.muNamedWidget.AWARDED_TO_GROUP as RadioList).muFetchData() === "AWARDED_TO_GROUP" ? 100 : 1;
        this.repeater.minCount = (this.muNamedWidget.AWARDED_TO_GROUP as RadioList).muFetchData() === "AWARDED_TO_GROUP" ? 2 : 1;

        while (this.repeater.minCount as number > (this.repeater.ui.items as HTMLElement).childElementCount)
        {
            this.repeater.addItem();
        }

        if (this.repeater.maxCount === 1) {
            this.repeater.clearItems(this.repeater.ui.items as HTMLElement, 0);
        }
    }
}

export class F24_COMPLEMENTARY_INFO extends BaseWidget {

}

export class DateWidget extends BaseWidget {
    override afterIndex() {
        this.ui.DATE_DISPATCH_NOTICE.innerText = new Date().toLocaleDateString("cs-CZ", { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
}
   
export class F24_2014_CURRENCY extends BaseWidget {
}

export class F24_2014_CURRENCY2 extends BaseWidget {
    override muBindData(src) {
        super.muBindData({VALUE: src});
    }

    override muFetchData() {
        return super.muFetchData().VALUE;
    }
}

export class F24_2014_CURRENCY3 extends BaseWidget {
    override muBindData(src) {
        super.muBindData({ VALUE: src });
    }

    override muFetchData() {
        return super.muFetchData().VALUE;
    }
}
